import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import moment from 'moment';

class CustomDateRangePicker extends Component {
  static propTypes = {
    handleDateChange: PropTypes.func,
    dateFormat: PropTypes.string,
    placeholderFrom: PropTypes.string,
    placeholderTo: PropTypes.string,
    labelFrom: PropTypes.string,
    labelTo: PropTypes.string,
    id: PropTypes.string,
    clearable: PropTypes.bool,
    clearDates: PropTypes.bool,
  };

  state = {
    startDate: null,
    endDate: null,
    placeholderFrom: 'Start Date',
    placeholderTo: 'End Date',
    id: 'date',
    clearable: false,
    clearDates: false,
    startDateError: false,
    endDateError: false,
  };

  UNSAFE_componentWillReceiveProps({ clearDates }) {
    if (clearDates) {
      this.setState({ startDate: null, endDate: null });
    }
  }

  handleDateChange = ({ startDate, endDate }) => {
    let fromDate = startDate || this.state.startDate;
    let toDate = endDate || this.state.endDate;

    if (moment(fromDate).isAfter(toDate)) {
      toDate = startDate;
    }

    if (!fromDate && toDate) {
      fromDate = moment(toDate).subtract(1, 'days');
    }

    if (fromDate && !toDate) {
      toDate = moment();
    }

    this.setState({ startDate: fromDate, endDate: toDate }, () => {
      this.props.handleDateChange({
        endDate: this.state.endDate,
        startDate: this.state.startDate,
      });
    });
  };

  handleStartDate = startDate => {
    this.setState(
      { startDate, startDateError: false, invalidDate: false },
      () => {
        this.handleStartDateOutsideClick();
        if (!this.state.endDate && this.startDateNode.calendar === undefined) {
          this.endDateNode.setFocus();
        } else {
          this.props.handleDateChange({
            endDate: this.state.endDate,
            startDate: this.state.startDate,
          });
        }
      }
    );
  };

  handleEndDate = endDate => {
    this.setState({ endDate, endDateError: false, invalidDate: false }, () => {
      this.handleEndDateOutsideClick();
      if (!this.state.startDate && this.endDateNode.calendar === undefined) {
        this.startDateNode.setFocus();
      } else {
        this.props.handleDateChange({
          endDate: this.state.endDate,
          startDate: this.state.startDate,
        });
      }
    });
  };

  handleOnStartDateBlur = event => {
    if (event.target.value) {
      const date = new Date(event.target.value);
      this.setState({ invalidDate: !moment(date).isValid() });
    } else {
      this.setState({ invalidDate: false });
    }
  };

  handleOnEndDateBlur = event => {
    if (event.target.value) {
      const date = new Date(event.target.value);
      this.setState({ invalidDate: !moment(date).isValid() });
    } else {
      this.setState({ invalidDate: false });
    }
  };

  handleStartDateOutsideClick = () => {
    const endError = !this.state.endDate;
    const startError = !this.state.startDate;
    if (!this.state.startDate && !this.state.endDate) {
      this.setState({ startDateError: false, endDateError: false });
    } else {
      this.setState({ endDateError: endError });
      this.setState({ startDateError: startError });
    }
  };

  handleEndDateOutsideClick = () => {
    const endError = !this.state.endDate;
    const startError = !this.state.startDate;
    if (!this.state.startDate && !this.state.endDate) {
      this.setState({ startDateError: false, endDateError: false });
    } else {
      this.setState({ endDateError: endError });
      this.setState({ startDateError: startError });
    }
  };

  handleClearDate = dateType => {
    this.setState({ [dateType]: null }, () => {
      const { endDate, startDate } = this.state;
      if (dateType === 'startDate') {
        this.startDateNode.setFocus();
      } else {
        this.endDateNode.setFocus();
      }
      if (!endDate && !startDate) {
        this.props.handleDateChange({ endDate, startDate });
      }
    });
  };

  render() {
    const {
      startDate,
      endDate,
      startDateError,
      endDateError,
      invalidDate,
    } = this.state;
    const {
      labelTo,
      labelFrom,
      id,
      placeholderFrom,
      placeholderTo,
      dateFormat,
      clearable,
    } = this.props;
    const isError =
      (endDate && startDateError) || (startDate && endDateError) || invalidDate;
    return (
      <div className="custom-date-picker">
        {endDate && startDateError && (
          <span className="date-error">From date is required.</span>
        )}
        {startDate && endDateError && (
          <span className="date-error">To date is required.</span>
        )}
        {invalidDate && <span className="date-error">Invalid Date</span>}
        <div
          className={`custom-date-picker--wrapper ${isError ? 'error' : ' '}`}
        >
          <div className="custom-date-picker--col">
            <div className="custom-date-picker--element">
              {labelFrom && (
                <label
                  className="custom-date-picker--label"
                  htmlFor={`${id}_from`}
                >
                  {labelFrom}
                </label>
              )}
              <DatePicker
                selected={startDate}
                selectsStart
                onChange={this.handleStartDate}
                onBlur={this.handleOnStartDateBlur}
                placeholderText={placeholderFrom}
                dateFormat={dateFormat}
                id={`${id}_from`}
                name={`${id}_from`}
                className="custom-date-picker--control"
                maxDate={endDate || new Date(moment())}
                startDate={startDate}
                endDate={endDate}
                ref={node => {
                  this.startDateNode = node;
                }}
                onClickOutside={this.handleStartDateOutsideClick}
              />
              {clearable && startDate && (
                <button
                  className="custom-date-picker--clear"
                  onClick={() => this.handleClearDate('startDate')}
                >
                  <i className="clear-x-icon" />
                </button>
              )}
            </div>
          </div>
          <div className="custom-date-picker--col">
            <div className="custom-date-picker--element">
              {labelTo && (
                <label
                  className="custom-date-picker--label"
                  htmlFor={`${id}_from`}
                >
                  {labelTo}
                </label>
              )}
              <DatePicker
                selected={endDate}
                selectsEnd
                onChange={this.handleEndDate}
                onBlur={this.handleOnEndDateBlur}
                placeholderText={placeholderTo}
                dateFormat={dateFormat}
                id={`${id}_to`}
                name={`${id}_to`}
                className="custom-date-picker--control"
                maxDate={new Date(moment())}
                minDate={startDate}
                startDate={startDate}
                endDate={endDate}
                ref={node => {
                  this.endDateNode = node;
                }}
                onClickOutside={this.handleEndDateOutsideClick}
              />
              {clearable && endDate && (
                <button
                  className="custom-date-picker--clear"
                  onClick={() => this.handleClearDate('endDate')}
                >
                  <i className="clear-x-icon" />
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CustomDateRangePicker;
